module.exports = __webpack_public_path__ + "img/mid-package.b4fd9582.png";